import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=a8c9a0d4&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8c9a0d4')) {
      api.createRecord('a8c9a0d4', component.options)
    } else {
      api.reload('a8c9a0d4', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=a8c9a0d4&", function () {
      api.rerender('a8c9a0d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28UhMlq8SYZHa/JS/videoIframe.vue"
export default component.exports